import script from "./PanelStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelStatistics.vue?vue&type=script&setup=true&lang=js"

import "./PanelStatistics.vue?vue&type=style&index=0&id=d3143380&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3143380"]])

export default __exports__